<style lang="less" scoped>
    .modal {
        /deep/.ivu-modal-body {
            min-height: 0;
        }
    }
</style>
<template>
  <div>
    <Modal
      v-model="showModal"
      class="modal"
      title="导出登记"
      :closable="false"
    >
      <div>
        <Form
          ref="formValidate" 
          :model="formItem"
          :label-width="80"
        >
          <FormItem 
            prop="date_range"
            label="时间范围"
            :rules="[{
              validator: (rule,value,callback)=>{
                if (!value||!value.length || value.every(item=>!item)) {
                  callback(new Error('时间范围不能为空'));
                } else {
                  callback();
                }
              },
              required: true, message: '时间范围不能为空', trigger: 'blur' }]"
          >
            <DatePicker
              v-model="formItem.date_range"
              type="daterange"
              placeholder="请选择时间范围"
              style="width: 360px"
              @on-change="selectDate"
            />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button
          @click="cancel"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="loading"
          @click="ok"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import { util_api } from '@/libs/util_api.js'
  const {file_stamp_download_list} = util_api
  export default {
    props: {
      display: {
        type: Number,
        default:() => null
      },
      formProps: {
        type:Object,
        default:() => ({})
      },
      loading:{
        type:Boolean,
        default:() => false
      }
    },
    data() {
      this.Error = Error
      return {
        showModal: false,
        title: '',
        formItem: {
          date_range: []
        }
      }
    },
    watch: {

    },
    methods: {
      selectDate(date) {
        this.formItem.date_range = date
      },
      show() {
        this.showModal = true
      },
      ok() {
        this.$refs.formValidate.validate((valid) => {
          if (valid) {
            const date_range = this.formItem.date_range
            window.open(file_stamp_download_list + `?start=${date_range[0]}&end=${date_range[1]}`, '_blank');
            this.showModal = false
          }
        })
      },
      cancel() {
        this.showModal = false
        this.formItem.date_range = ['', '']
        this.$emit('cancel')
      }
    }
  }
</script>
